import { serializeDocument } from 'anodum';

import instance from '../instance';

const getMappedHTML = () => {
  const liveDOM = instance.driver.getLiveDocument();

  return serializeDocument(liveDOM);
};

export default getMappedHTML;
